import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../Lg.css';
import {useHistory} from "react-router-dom";
import {logPageOpened} from "../../model/utils";
import {useEffect} from "react";
import {appdata} from "../../../logic_tmp/appdata/AppData";

export function LgTeamFooter() {
    appdata.viewType = "ReferencePage"
    useEffect(() => {
        //TODO optimize, introduce Logger as file
        logPageOpened(appdata.parentPath,appdata.viewType)
    }, []);
    const history = useHistory();

    return (
        <div>
            <Container>
                <Row>
                    <Col>
                        <br/>
                        <div>
                            <a onClick={() => history.goBack()} className="myButton myButtonYellow">Назад к
                                страничке концерта</a>
                        </div>
                        <br/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

